import { useEffect, useState } from "react";
import { BasicTable, MASK_DATE } from "../../../../theme/Component/BasicTable"
import { Modal } from "../../../../theme/Component/Modal"
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm"
import { _RequestTypeBpmAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { AccountEditor } from "../../../../editor/AccountEditor";

interface Props {
    requestTypeBPM: number;
}

export const RequestTypeBpmAccount = ({ requestTypeBPM }: Props) => {


    const { instance, setBean, bean, setLista, lista } = useDataBean(_RequestTypeBpmAccount)

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (requestTypeBPM) {
            getLista()
        }
    }, [requestTypeBPM]);

    const getLista = () => {
        const x = {
            IDRequestTypeBpm: requestTypeBPM,
            State: 1,
        }
        instance.getRequestTypeBpmAccountCatalogPorPropiedades(x, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const eliminarItem = () => {
        bean.State = 2;
        updateItem();
    }

    const updateItem = () => {
        instance.updateRequestTypeBpmAccount(bean).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalConfirm({ ...modalConfirm, "view": false });
            }
        ).catch(err => { console.log(err) })
    }

    const agregarItem = () => {
        setBean({
            IDRequestTypeBpm: requestTypeBPM,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar un Usuario" })
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const head = [
        { title: 'ID', property: 'IDRequestTypeBpmAccount', visible: true },
        { title: 'IDRequestTypeBpm', property: 'IDRequestTypeBpm' },
        { title: 'IDAccount', property: 'IDAccount' },
        { title: 'IDEmployee', property: 'IDEmployee' },
        { title: 'State', property: 'State', visible: true },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
    ]

    return (
        <div className="row">
            <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => {
                    if (bean.IDAccount) {
                        updateItem()
                    } else {
                        toast.error("Debe Seleccionar un Usuario Valido");
                    }
                }}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor idAccount={bean.IDAccount} label="Usuario" onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }); }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={() => { eliminarItem() }}>
                    ¿Desea Eliminar el item {bean.IDRequestTypeBpmAccount}?
                </ModalConfirm>
            </div>
        </div>
    )
}